module.exports = __webpack_public_path__ + "img/lch.4b208877.jpg";